// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-merge-wrapper {
  width: 100%;
}

.work-merge-start-request {
  width: 23%;
  margin-left: auto;
  margin-bottom: 1.6rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/WorkMerge/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,UAAA;EACA,iBAAA;EACA,qBAAA;AACF","sourcesContent":[".work-merge-wrapper {\n  width: 100%;\n}\n\n.work-merge-start-request {\n  width: 23%;\n  margin-left: auto;\n  margin-bottom: 1.6rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
